export const VossApplicationScopes = {
    Any: 0,
    SubscriptionCustomer: 1,
    NonSubscriptionCustomerInvoiceRecipient: 2,
};

export const VossApplicationScopesText = {
    [VossApplicationScopes.Any]: 'vossapplicationscopes.any',
    [VossApplicationScopes.SubscriptionCustomer]: 'vossapplicationscopes.subscriptioncustomer',
    [VossApplicationScopes.NonSubscriptionCustomerInvoiceRecipient]: 'vossapplicationscopes.nonsubscriptioncustomerinvoicerecipient',
};